import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { ImportActionContext } from "./ImportActionContext";

function useImport() {
  const { element, setBackendFormErrors } = useContext(ImportActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    store("movements/import", element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useImport;
